import React, { useState,useEffect } from 'react';
import { FaBars, FaTimes} from 'react-icons/fa';
import NavBar from './NavBar';
import { Link, useLocation } from 'react-router-dom';
import './PrivacyPolicy.css';
import abt_first from './assets/images/about-us-first-image-1-scaled.jpg';
import first from './assets/images/Privacy-TOS-banner-1.jpg';
import second from './assets/images/Privacy-TOS-banner-3.jpg';
import logo from './assets/images/favicon1.webp';
import logo1 from './assets/images/0040C0.png';

const PrivacyPolicy = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
      document.title = "Privacy Policy – Bay Capital Advisors";
      
      // Find and update the favicon
      let favicon = document.querySelector("link[rel~='icon']");
      if (!favicon) {
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        document.head.appendChild(favicon);
      }
      favicon.href = logo; // Use your logo as favicon
      
      return () => {
        // Reset title when component unmounts if needed
        document.title = "Bay Capital Advisors";
      };
    }, []);
                  
                    const toggleMobileMenu = () => {
                      setIsMobileMenuOpen(!isMobileMenuOpen);
                    };
                  
                    const closeMobileMenu = () => {
                      setIsMobileMenuOpen(false);
                    };
  return (
    <div className="privacy-policy-page">
      <div className="mobile-menu-button" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      
      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-dropdown-overlay" onClick={closeMobileMenu}>
          <div className="mobile-dropdown" onClick={(e) => e.stopPropagation()}>
            <NavBar isMobile={true} closeMenu={closeMobileMenu} />
          </div>
        </div>
      )}
      <section class="hero9">
      <div class="blue-overlay"></div>
    
      <header class="header9">
      <NavBar />
    </header>
      <header className="privacy-policy-header">
        
          <h1>PRIVACY POLICY</h1>
        
      </header>
      </section>

      <div className="privacy-policy-content">
        
          <p>Bay Capital Advisors (BCA) respects the privacy of every individual who visits BCA’s website. In dealing with BCA, you may provide BCA with personal information about yourself, your company, and any other affiliations that you may have. The purpose of this statement is to set out the principles governing BCA’s use of personal information that BCA may obtain about you. By using the BCA websites you consent to the use of your personal information in accordance with the terms of this Policy.</p>
          <p>
          1. “BCA” means Bay Capital Advisors, Incorporated and any of its subsidiaries, affiliates, and related companies.
          </p>
          <p>
          2. BCA is committed to following policies that protect your privacy and comply with current international data protection laws and regulations in respect of personal data. BCA will only obtain personal data from you for specified and lawful purposes and any personal data which BCA obtains will be processed fairly and lawfully.          </p>
          <p>
          3. BCA collects personal data for use in the normal course of BCA’s business. Your personal data may be held and processed in connection with a transaction that BCA considers with you, for the general development of BCA’s business and for administrative purposes relating to those purposes. BCA may use the contact details that you provide to BCA to inform you of relevant opportunities, developments and events, unless you decide to opt out. You may opt out by notifying us thru email using our on-line form available on the ‘Contact Us’ page of our websites.
          </p>
          <p>
          4. BCA will only process the individual data that you provide to BCA for these purposes. BCA will take all reasonable steps to ensure that the data held is adequate, relevant and not excessive for the relevant purposes.
          </p>
          <p>
          5. Please note that the information that you provide to BCA is processed and held on computer systems and files of the BCA group of companies throughout the world. This may include companies, offices or data centres outside the United States and the European Economic Area. All BCA group companies and affiliates maintain the same levels of data protection, confidentiality and security. In certain cases for business development and transactional purposes your information may be passed to companies who process data on behalf of BCA, BCA’s advisers, financial intermediaries and credit reference agencies with which BCA works. Where BCA passes data to third parties BCA ensures that appropriate confidentiality arrangements are in place. BCA does not provide your details to third parties for any marketing or promotional purposes, except where you have given your consent.
          </p>
          <p>
          6. The servers hosting BCA’s websites automatically record certain information about you when you use the sites, including details of your domain name, IP address, operating system and browser. BCA may use this information to understand who has seen which pages in order that BCA can monitor and improve BCA’s websites. BCA may use cookies or other similar text files or programs when you visit certain parts of the BCA websites. A cookie is a small file that is sent to your browser and helps BCA to understand your use of the BCA websites and enables you to access, navigate and use the services provided on the BCA websites. For information about blocking the use of cookies, please refer to the instructions/help screen on your Internet browser. Please note that if you block cookies you may not be able to access certain online services provided on the BCA websites.
          </p>
          
          <img src={second} alt="About us image" className="city-image10" />

          <p style={{ fontWeight: 'bold' }}>
          Accuracy and Security
          </p>
          <p>
          7. BCA will take all reasonable steps to keep your personal information accurate and, where necessary, up to date. If you believe that any of the information that BCA holds about you is incorrect please notify BCA (see “Contacts”).
          </p>
          <p>
          8. BCA will take all reasonable steps to protect the confidentiality and security of your personal information, but cannot guarantee the security of any data you disclose online. You accept the inherent security risks of providing information online over the Internet and will not hold BCA responsible for any breach of security unless this is due to BCA’s negligence or willful default.
          </p>
          <p>
          9. BCA’s websites may contain hypertext links to external websites. BCA is not responsible for and accepts no liability in relation to these websites or their contents. You should read any applicable privacy policy on any such website. Also, BCA assumes no liability for the content and the accuracy of information on these external websites. The information and links are provided only as a resource for informational purposes and any content should be verified and consulted upon with an appropriate professional in the respective area before any business or economic decision is made.
          </p>

          <img src={first} alt="About us image" className="city-image11" />

          <p style={{ fontWeight: 'bold' }}>
          Your rights
          </p>
          <p>
          10. BCA will take all reasonable steps to retain data only for the duration of the purpose for which it was obtained. When requested to do so, BCA will delete personal information from current operational systems where it is no longer required. BCA may need to continue to hold some details about you after your relationship with BCA has ended, for example for legal and regulatory reasons.
          </p>
          <p>
          11. You have the right to receive information about the personal data (as defined in the Data Protection Act 1998) that BCA maintains on you (a fee may be payable). You should also note that, under data protection laws, in certain circumstances you are entitled to object to the processing of your personal data and have certain rights of access, rectification and/or removal of your personal data. To exercise these rights you should write to BCA.
          </p>
          <p style={{ fontWeight: 'bold' }}>
          Changes to BCA’s Privacy Policy
          </p>
          <p>
          12. Any changes to this Privacy Policy will be posted here, so please check BCA’s Privacy Policy on a regular basis when you visit the BCA website, and especially when you submit personal and sensitive information via our website or thru email.
          </p>
          <p style={{ fontWeight: 'bold' }}>
          Last updated on 26 June 2024
          </p>
          


      </div>

      <div className='separate-p'>
      <p style={{
                color: 'inherit',         
                textDecoration: 'underline', 
                cursor: 'default'         
                }}>
            
                Copyright 2025
           
            </p>
      </div>

      {/* Footer Section */}
     <div className="footer-section">
        <nav>
          <a href="/CoreValues">Core Values</a>
          <a href="/Resources">Resources</a>
          <a href="/ContactUs">Contact Us</a>
        </nav>
        <div className="footer-logo">
                <Link to="/"> {/* Add this Link wrapper */}
                  <img src={logo1} alt="Bay Capital Advisors Logo" className="logo" />
                </Link>
                </div>
        <nav>
          <a href="/PrivacyPolicy">Privacy Policy</a>
          <a href="/TermsOfService">Terms of Service</a>
        </nav>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
